import styled from 'styled-components';

export const Header = styled.header`
  position: relative;
  z-index: 91;
  height: 50px;
  background: #333;
  transition: all 0.3s;
  display: block;

  @media (max-width: 1099px) {
    z-index: 999;
  }

  .search {
    width: 50px;
    height: 50px;
    fill: #fff;
  }

  .arabic {
    fill: #fff;
    margin-top: 5px;
  }

  ul {
    margin: 0;
    padding: 0;
    list-style-type: none;
  }

  &[dir='ltr'] {
    a {
      letter-spacing: 1.29px;

      @media (max-width: 413px) {
        letter-spacing: normal;
      }
    }
  }

  .active {
    a {
      color: #fff;
    }
  }

  &.isSticky {
    nav {
      .secondary {
        @media (min-width: 1100px) {
          height: 180px;
        }

        .third-level-menu {
          @media (min-width: 1100px) {
            margin-top: 12px;
          }

          a {
            @media (min-width: 1025px) {
              &:hover {
                color: ${({ dir }) => (dir === 'rtl' ? '#000!important' : '')};
              }
            }
          }
        }

        .logo {
          padding: ${({ dir }) => (dir === 'rtl' ? '10px 0 0 15px' : '0px 15px 0 0')};
          margin-top: -12px;
          @media (max-width: 1099px) {
            padding: ${({ dir }) => (dir === 'rtl' ? '0 15px 0 0' : '0 0 0 15px')};
            margin-top: 0px;
          }
          justify-content: center;

          .dwtclogo {
            background-image: url(/svg/sprites.svg#dwtclogo);
          }
        }

        &.secondary-page-nav {
          .logo {
            .dwtclogo {
              background-image: url(/svg/sprites.svg#dwtclogo);
            }
          }
        }
      }
    }

    div[class*='SearchContainerstyled__MenuCloseButton-'] {
      display: block;
    }

    div[class*='NavSecondarystyled__Secondary-'] {
      background: #fff;
      position: fixed;
      width: 100%;
      z-index: 109;
      top: 0;
      transition-property: background;
      transition-duration: 0.8s;
      transition-timing-function: ease;

      @media (max-width: 1099px) {
        background: transparent;
        position: absolute;
        height: inherit;
        width: 100%;
        top: inherit;
      }

      ul {
        li {
          @media (min-width: 1100px) {
            border-color: #ebebeb;
          }
          @media (max-width: 1099px) {
            border-color: #666;
          }
          a {
            color: #333;
            @media (max-width: 1099px) {
              color: #fff;
            }
          }
        }
      }
    }

    .s-menu {
      @media (min-width: 1100px) {
        padding: 20px 0;
      }
      @media (max-width: 1099px) {
        padding: 20px 0;
      }
    }

    .third-level-menu {
      @media (min-width: 1100px) {
        background: #f5f5f5;
      }
    }

    .has-submenu {
      &:hover {
        a {
          &:after {
            border-color: #000;
          }
        }
      }
    }

    .fix {
      height: 142px !important;
      transition: all 0.3s !important;

      .logo {
        padding: 0px 15px 0 0;
        margin-top: 0px !important;
      }

      @media (max-width: 1030px) {
        height: calc(165px - 50px) !important;
      }

      div[class*='SearchContainerstyled__MenuCloseButton-'] {
        display: block;
      }

      .third-level-menu {
        @media (min-width: 1100px) {
          margin-top: 0px !important;
        }
      }
    }
  }
`;
